module.exports = __webpack_public_path__ + "images/emoji/white_check_mark.191a6345b3b5561bad72.png";